module.exports = __webpack_public_path__ + "img/printstat-rgb-icon.4d9c1b9d.png";